import { constants } from '~/constants';

export const getGridStyle = (type: string, value: number) => {
  let style = null;

  if (type) {
    if (Array.isArray(constants[type])) {
      style = constants[type].find(
        (element: { value: number; title: string; detail: string; type?: string }) =>
          element.value === value
      );
    } else {
      style = constants[type][value];
    }
  }

  return style;
};
